import { EmojiType, GetEmoji } from '@ui-components/assets/Emojis'
import { ReactNode } from 'react'
import { styled } from 'styled-components'

import { Colors } from '../../global/colors'
import { MainHeading } from './headingPrimitives'
import { StandardHeading, StandardHeadingProps } from './StandardHeading'

export interface PrimaryHeadingProps extends StandardHeadingProps {
  header: string
  headerCaption?: ReactNode
  id?: string
  additionalText?: ReactNode
  leadText?: ReactNode
  bodyText?: ReactNode
  tagName?: 'h1' | 'h2'
  emoji?: EmojiType
  isInfoHeading?: boolean
  className?: string
}

const Heading = styled(MainHeading)`
  overflow-wrap: break-word;
  word-wrap: break-word;
  hyphens: auto;
  -ms-hyphens: auto;
  -moz-hyphens: auto;
  -webkit-hyphens: auto;
  hyphenate-limit-chars: 10 5 5;
  -ms-hyphenate-limit-chars: 10 5 5;
  -moz-hyphenate-limit-chars: 10 5 5;
  -webkit-hyphenate-limit-chars: 10 5 5;
`

const EmojiWrapper = styled.div<{ $color: string }>`
  color: ${({ $color }) => $color};
`

export const PrimaryHeading = ({
  header,
  tagName = 'h1',
  id,
  emoji,
  isInfoHeading = false,
  ...rest
}: PrimaryHeadingProps) => {
  const color = isInfoHeading ? Colors.TextStrongestPrimary : Colors.TextMediumPrimary

  return (
    <StandardHeading
      header={
        <>
          {emoji && <EmojiWrapper $color={color}>{GetEmoji(emoji)}</EmojiWrapper>}
          <Heading tagName={tagName} id={id ?? 'main-heading'} color={color}>
            {header}
          </Heading>
        </>
      }
      {...rest}
      color={isInfoHeading ? color : undefined}
    />
  )
}
